import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFlag1"><Path d="M5.5 2C4.67157 2 4 2.67157 4 3.5V21.5C4 21.7761 4.22386 22 4.5 22C4.77614 22 5 21.7761 5 21.5V16H19.4604C20.6339 16 21.3529 14.7133 20.7379 13.7139L17.9984 9.26205C17.8995 9.10135 17.8995 8.89865 17.9984 8.73795L20.7379 4.28615C21.3529 3.28674 20.6339 2 19.4604 2H5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFlag1;
